import { render, staticRenderFns } from "./rfmDetail.vue?vue&type=template&id=231ca558&scoped=true"
import script from "./rfmDetail.vue?vue&type=script&lang=js"
export * from "./rfmDetail.vue?vue&type=script&lang=js"
import style0 from "./rfmDetail.vue?vue&type=style&index=0&id=231ca558&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "231ca558",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/test-cdp-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('231ca558')) {
      api.createRecord('231ca558', component.options)
    } else {
      api.reload('231ca558', component.options)
    }
    module.hot.accept("./rfmDetail.vue?vue&type=template&id=231ca558&scoped=true", function () {
      api.rerender('231ca558', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/newLabelManagement/labelManagement/rfmDetail.vue"
export default component.exports